import PaymentSuccessPage from './payment-success-page'
export default PaymentSuccessPage;